
const digest = '53d10a03ad6269dc2c35d7e668dee23ad4174fa4ace34ff3a49633f433604287';
const classes = {"wrapper":"_wrapper_1ltrn_1","formWrapper":"_formWrapper_1ltrn_5","packageListWrapper":"_packageListWrapper_1ltrn_9","controls":"_controls_1ltrn_14","packageListIframe":"_packageListIframe_1ltrn_19"};
const css = `._wrapper_1ltrn_1 {
  display: flex;
  gap: 20px;
}
._wrapper_1ltrn_1 ._formWrapper_1ltrn_5 {
  overflow-y: auto;
  overflow-x: hidden;
}
._wrapper_1ltrn_1 ._packageListWrapper_1ltrn_9 {
  flex: 1;
  border-left: 1px solid #e5e5e5;
  padding-left: 15px;
}
._wrapper_1ltrn_1 ._packageListWrapper_1ltrn_9 ._controls_1ltrn_14 {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
._wrapper_1ltrn_1 ._packageListWrapper_1ltrn_9 ._packageListIframe_1ltrn_19 {
  height: 100%;
  width: 100%;
  border: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  